import React, { useState, useEffect } from "react";
import { Container, Card, CardBody, Button, Input, InputGroup, InputGroupText, Spinner, Row, Col, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { useAuth } from "../../Context/AuthenticateProvider";
import { setProfile } from '../../Reducer/customerSlice';
import { setCookie } from "../../Helpers/Utils";
import Logo from "../../Assets/images/logo.png";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector(state => state.loading.loading);
  const { logIn, user } = useAuth();

  const [showPwd, setShowPwd] = useState(false);
  const [remember, setRemember] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });

  useEffect(() => {
    if (user) {
      if (user.role === 'staff') {
        window.location.replace("/staff-welcome");
      } else if (user.role === 'admin') {
        navigate("/");
      }
    }
  }, [user, navigate]);

  useEffect(() => {
    const saved = localStorage.getItem("billing_login");
    if (saved) {
      setForm(JSON.parse(saved));
      setRemember(true);
    }
  }, []);

  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const submit = async (e) => {
    if (e) e.preventDefault();
    if (!form.email || !isValidEmail(form.email) || !form.password) {
      toast.error("Please fill all fields correctly");
      return;
    }
    dispatch(loadingTrue());
    try {
      const res = await Handler({ method: "post", url: "/auth/login.php", data: form });
      if (res?.success) {
        if (remember) {
          localStorage.setItem("billing_login", JSON.stringify(form));
          dispatch(loadingFalse());
        } else {
          localStorage.removeItem("billing_login");
        }
        setCookie("auth_token", res.data.token, 7);
        setCookie("user_data", JSON.stringify(res.data.user), 7);
        dispatch(setProfile(res?.data?.user));
        toast.success(res.message || "Login Success!");
        setTimeout(() => {
          logIn(res.data.token, res.data.user);
        }, 500);
      } else {
        dispatch(loadingFalse());
        toast.error(res?.message || "Invalid Credentials");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      dispatch(loadingFalse());
    }
  };

  return (
    <div className="login-wrapper d-flex align-items-center justify-content-center py-4" 
      style={{ minHeight: '100vh', backgroundColor: '#f4f7fe', overflowX: 'hidden' }}>
      <Container>
        <Row className="justify-content-center align-items-center g-4">
          
          {/* Logo Section - Responsive scaling */}
          <Col xs={12} lg={5} className="text-center d-flex justify-content-center">
            <div style={{ maxWidth: '100%', width: '380px' }}>
              <img src={Logo} alt="Logo" className="img-fluid" 
                style={{ 
                  maxHeight: '280px', 
                  width: 'auto',
                  filter: 'drop-shadow(0 10px 15px rgba(0,0,0,0.1))' 
                }} />
            </div>
          </Col>

          {/* Login Card Section */}
          <Col xs={12} sm={10} md={8} lg={5} xl={4}>
            <Card className="border-0 shadow-lg" style={{ borderRadius: '24px' }}>
              <CardBody className="p-4 p-md-5">
                <div className="text-center mb-4">
                    <h2 className="fw-bolder" style={{ color: '#1B2559', fontSize: 'clamp(1.5rem, 5vw, 2rem)' }}>
                        Muthiah Cotton
                    </h2>
                    <p className="text-muted small">Enter your credentials to access the system</p>
                </div>

                {/* Normal HTML form use panni error-ah fix pannittaen */}
                <form onSubmit={submit}>
                  <FormGroup className="mb-3">
                    <Label className="small fw-bold text-dark">Email address *</Label>
                    <Input
                      type="email"
                      name="email"
                      placeholder="admin@gmail.com"
                      value={form.email}
                      onChange={onChange}
                      className="border-1"
                      style={{ borderRadius: '12px', padding: '12px', borderColor: '#E2E8F0' }}
                    />
                  </FormGroup>

                  <FormGroup className="mb-3">
                    <Label className="small fw-bold text-dark">Password *</Label>
                    <InputGroup style={{ borderRadius: '12px', overflow: 'hidden' }}>
                      <Input
                        type={showPwd ? "text" : "password"}
                        name="password"
                        placeholder="••••••••"
                        value={form.password}
                        onChange={onChange}
                        style={{ padding: '12px', borderRight: 'none', borderColor: '#E2E8F0' }}
                      />
                      <InputGroupText
                        className="bg-white"
                        style={{ cursor: 'pointer', borderColor: '#E2E8F0', borderLeft: 'none' }}
                        onClick={() => setShowPwd(!showPwd)}
                      >
                        <i className={`bx ${showPwd ? "bx-show" : "bx-hide"} text-muted fs-5`}></i>
                      </InputGroupText>
                    </InputGroup>
                  </FormGroup>

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <FormGroup check className="d-flex align-items-center">
                        <Input 
                            type="checkbox" 
                            id="rememberCheck"
                            checked={remember} 
                            onChange={() => setRemember(!remember)} 
                        />
                        <Label className="ms-2 small text-muted mb-0" for="rememberCheck" style={{ cursor: 'pointer' }}>
                            Remember me
                        </Label>
                    </FormGroup>
                    <a href="/forget-password" className="small text-decoration-none fw-bold" style={{ color: '#4318FF' }}>Forgot?</a>
                  </div>

                  <Button
                    block
                    type="submit"
                    disabled={loading}
                    className="py-3 border-0 shadow-sm"
                    style={{ 
                        backgroundColor: '#4318FF', 
                        borderRadius: '16px', 
                        fontWeight: '700', 
                        fontSize: '16px'
                    }}
                  >
                    {loading ? <Spinner size="sm" /> : "Login Account"}
                  </Button>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;